import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";

interface TabSkeletonProps {
  rows?: number;
}

export default function TabSkeleton({ rows = 3 }: TabSkeletonProps) {
  return (
    <div className="p-4">
      <Card>
        <div className="mb-4">
          <Skeleton width="60%" height="1.5rem" className="mb-4" />
          <div className="flex flex-col gap-3">
            {Array.from({ length: rows }, (_, i) => (
              <div key={i} className="border-surface-border rounded-lg p-3">
                <Skeleton width="100%" height="2.5rem" />
              </div>
            ))}
          </div>
        </div>
        <div className="flex gap-2 mt-4 justify-end">
          <Skeleton width="10rem" height="2.5rem" />
          <Skeleton width="6rem" height="2.5rem" />
        </div>
      </Card>
    </div>
  );
}
